import React, { useState } from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';
import EsignWorkflowDiagram from './EsignWorkflowDiagram';

function Verify() {
  const [selectedApi, setSelectedApi] = useState('bank');

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    requiredApis: 'All Verify APIs Suite',
    subject: 'Sandbox API Key Request',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error' | null

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitStatus(null);

    try {
      const body = new URLSearchParams();
      body.append('action', 'ADD');
      body.append('name', formData.name);
      body.append('email', formData.email);
      body.append('phone', formData.phone);
      body.append('company_url', 'retailer.mokshiq.in');
      body.append('subject', formData.subject);
      body.append(
        'message',
        `${formData.message}\n\nRequired Verification APIs: ${formData.requiredApis}`
      );

      const response = await fetch('https://api.mokshiq.in/enquiry-action', {
        method: 'POST',
        headers: {
          Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoyMDg1LCJjbGllbnRfaWQiOiJjc2Mua3J5bnRpcS5jb20iLCJqdGkiOiIzN2EwNjYyYi04NDg1LTQ0YWUtOTg0ZS03ZjNhOWZiYzMzYjgiLCJpYXQiOjE3ODc0MDA3MTUsImV4cCI6MjEwMjc2MDcxNX0.EhMHAZw7sXm1Q6TCtRlryqBDTwQ68XSHMOq_MQ3B-kk',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: body.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          requiredApis: 'All Verify APIs Suite',
          subject: 'Sandbox API Key Request',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (err) {
      setSubmitStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  const apiDetails = {
    bank: {
      name: "Bank Account Penny Drop Verification",
      icon: "fa-building-columns",
      badge: "Instant Name Match",
      description: "Verify account holder name instantly before initiating Payouts, Salary Transfers, or Refunds. Prevents transfer errors and reduces fraudulent chargebacks.",
      requestSample: `{
  "api_key": "YOUR_MOKSHIQ_API_KEY",
  "account_number": "918273645012",
  "ifsc": "HDFC0001234"
}`,
      responseSample: `{
  "status": "SUCCESS",
  "response_code": 200,
  "data": {
    "account_exists": true,
    "account_holder_name": "RAKLE SERVICE PRIVATE LIMITED",
    "utr": "423819028341",
    "bank_name": "HDFC Bank Ltd",
    "message": "Account Verification Successful"
  }
}`
    },
    pan: {
      name: "Instant PAN Card Verification API",
      icon: "fa-id-card",
      badge: "NSDL / ITD Direct",
      description: "Verify PAN validity, category, name on card, and Aadhaar linking status directly with NSDL and Income Tax Department databases in real-time.",
      requestSample: `{
  "api_key": "YOUR_MOKSHIQ_API_KEY",
  "pan": "ABCDE1234F"
}`,
      responseSample: `{
  "status": "SUCCESS",
  "response_code": 200,
  "data": {
    "valid": true,
    "name_on_card": "MOKSHIQ USER",
    "pan_type": "INDIVIDUAL",
    "aadhaar_seeding_status": "LINKED",
    "status": "OPERATIONAL"
  }
}`
    },
    aadhaar: {
      name: "Aadhaar Verification (OTP & Offline XML)",
      icon: "fa-fingerprint",
      badge: "Biometric-Less Paperless KYC",
      description: "Authenticate Aadhaar via UIDAI OTP or Offline XML download without requiring physical biometric scanners. Compliant with RBI & UIDAI KYC norms.",
      requestSample: `{
  "api_key": "YOUR_MOKSHIQ_API_KEY",
  "aadhaar_number": "999988887777",
  "consent": "Y"
}`,
      responseSample: `{
  "status": "SUCCESS",
  "response_code": 200,
  "data": {
    "otp_sent": true,
    "ref_id": "REF981273912",
    "masked_mobile": "XXXXXX4571",
    "message": "OTP sent to registered mobile number"
  }
}`
    },
    gst: {
      name: "GSTIN Search & Taxpayer Verification API",
      icon: "fa-receipt",
      badge: "GSTN Live Database",
      description: "Fetch taxpayer business registration name, filing status, trade name, address, taxpayer type, and compliance score using 15-digit GSTIN.",
      requestSample: `{
  "api_key": "YOUR_MOKSHIQ_API_KEY",
  "gstin": "07AAAAA0000A1Z5"
}`,
      responseSample: `{
  "status": "SUCCESS",
  "response_code": 200,
  "data": {
    "trade_name": "RAKLE SERVICE PRIVATE LIMITED",
    "legal_name": "RAKLE SERVICE PRIVATE LIMITED",
    "status": "ACTIVE",
    "taxpayer_type": "REGULAR",
    "address": "1st Floor, C 78, Sector-2 Noida"
  }
}`
    },
    upi: {
      name: "UPI VPA / Handle Verification API",
      icon: "fa-mobile-retro",
      badge: "Real-Time NPCI Lookup",
      description: "Validate Virtual Payment Addresses (e.g. user@upi) and retrieve account owner's registered name instantly before collecting or disbursing funds.",
      requestSample: `{
  "api_key": "YOUR_MOKSHIQ_API_KEY",
  "vpa": "7311104571@upi"
}`,
      responseSample: `{
  "status": "SUCCESS",
  "response_code": 200,
  "data": {
    "vpa_valid": true,
    "payee_name": "RAKLE SERVICE PVT LTD",
    "vpa": "7311104571@upi"
  }
}`
    },
    rc_dl: {
      name: "Vehicle RC & Driving License Verification API",
      icon: "fa-car",
      badge: "Parivahan Transport Database",
      description: "Retrieve vehicle owner details, insurance validity, PUCC status, vehicle class, and driver license authenticity from national transport registers.",
      requestSample: `{
  "api_key": "YOUR_MOKSHIQ_API_KEY",
  "vehicle_number": "UP16AB1234"
}`,
      responseSample: `{
  "status": "SUCCESS",
  "response_code": 200,
  "data": {
    "rc_status": "ACTIVE",
    "owner_name": "MOKSHIQ FLEET",
    "maker_model": "HYUNDAI CRETA",
    "fuel_type": "PETROL",
    "insurance_valid_upto": "2027-12-31"
  }
}`
    }
  };

  const VerifyFaqs = [
    {
      question: "What is Mokshiq Verify?",
      answer: "Verify is Mokshiq's flagship developer-friendly API suite that enables instant automated verification of Bank Accounts, PAN Cards, Aadhaar, GSTIN, UPI VPAs, Driving Licenses, and Vehicle RCs."
    },
    {
      question: "How fast are the verification API responses?",
      answer: "Our APIs deliver ultra-fast average response times under 500ms with a guaranteed 99.9% uptime powered by direct integrations with bank and government nodes."
    },
    {
      question: "How can I request Sandbox API credentials for testing?",
      answer: "You can request instant Sandbox access by filling out the form on this page or contacting our Sales team at sales@mokshiq.in / +91 7311104571."
    },
    {
      question: "Are Verify APIs compliant with regulatory guidelines?",
      answer: "Yes. All verification modules operate strictly with user consent mechanisms and comply with RBI, NPCI, UIDAI, and NSDL data security standards."
    }
  ];

  // Shared style for all form inputs/select/textarea so typed text is always
  // clearly visible (dark text) regardless of any global/dark-theme CSS
  // that might otherwise make the text inherit a light color on this
  // light background.
  const fieldStyle = {
    borderRadius: '0 10px 10px 0',
    backgroundColor: '#f8fafc',
    padding: '0.7rem 0.75rem',
    color: '#0f172a',
    caretColor: '#0f172a'
  };

  const textareaStyle = {
    borderRadius: '10px',
    backgroundColor: '#f8fafc',
    padding: '0.7rem 0.75rem',
    color: '#0f172a',
    caretColor: '#0f172a'
  };

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        
        {/* Hero Section */}
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-shield-check me-2"></i>Verify API Suite
            </span>
            <h1 className="page_title text-white mb-3">Instant Identity &amp; Verification APIs</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Automate customer onboarding, prevent fraud, and ensure 100% KYC compliance with Mokshiq Verify APIs (Powered by <strong>Rakle Service Private Limited</strong>).
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Services</a></li>
              <li className="active"><a href="#!">Verify</a></li>
            </ul>
          </div>
        </section>

        {/* Multi-Signer eSign Interactive Component */}
        <section className="verification_diagram_section section_space bg-light">
          <div className="container">
            <EsignWorkflowDiagram title="Multi-Signer Contract Agreement &amp; Digital eSign Workflow" />
          </div>
        </section>

        {/* Verification API Selector Grid */}
        <section className="verify_grid section_space bg-white">
          <div className="container">
            <div className="heading_block text-center mb-5">
              <h2 className="heading_text text-dark mb-2">Comprehensive Verification APIs</h2>
              <p className="heading_description text-muted">Select an API below to view features, sample request parameters, and live JSON response models.</p>
            </div>

            <div className="row g-3 mb-5">
              {Object.keys(apiDetails).map((key) => {
                const api = apiDetails[key];
                const isSelected = selectedApi === key;
                return (
                  <div key={key} className="col-md-6 col-lg-4">
                    <div 
                      className={`card h-100 p-4 shadow-sm rounded-4 cursor-pointer border ${isSelected ? 'border-2 border-warning bg-white shadow' : 'bg-white'}`}
                      onClick={() => setSelectedApi(key)}
                      style={{ cursor: 'pointer', transition: 'all 0.3s ease', borderColor: isSelected ? '#d97706' : '#e2e8f0' }}
                    >
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className={`icon_box p-3 rounded-circle d-inline-flex align-items-center justify-content-center ${isSelected ? 'bg-warning text-dark' : 'bg-dark text-warning'}`} style={{ width: '50px', height: '50px' }}>
                          <i className={`fa-solid ${api.icon} fa-lg`}></i>
                        </div>
                        <span className="badge px-3 py-2 font-weight-bold shadow-sm" style={{ backgroundColor: '#0f172a', color: '#f59e0b', fontSize: '11px', letterSpacing: '0.4px', borderRadius: '20px' }}>
                          {api.badge}
                        </span>
                      </div>
                      <h4 className="card-title h5 font-weight-bold mb-2" style={{ color: '#0f172a' }}>{api.name}</h4>
                      <p className="card-text small mb-3" style={{ color: '#475569', lineHeight: '1.5' }}>{api.description}</p>
                      <div className="mt-auto pt-3 border-top small font-weight-bold d-flex align-items-center justify-content-between" style={{ color: isSelected ? '#15803d' : '#d97706', borderColor: '#f1f5f9' }}>
                        <span>{isSelected ? 'Viewing API Details' : 'Click to Inspect API'}</span>
                        <i className={`fa-solid ${isSelected ? 'fa-circle-check text-success' : 'fa-chevron-right'}`} style={{ color: isSelected ? '#16a34a' : '#64748b' }}></i>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Live API Console / Inspector */}
            <div className="api_console bg-dark text-light p-4 p-lg-5 rounded-3 shadow-lg">
              <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 pb-3 border-bottom border-secondary">
                <div>
                  <span className="badge bg-success text-dark fw-bold mb-1">LIVE API DOCS</span>
                  <h3 className="h4 text-warning mb-0">{apiDetails[selectedApi].name}</h3>
                </div>
                <div className="mt-2 mt-md-0">
                  <a href="mailto:sales@mokshiq.in?subject=Sandbox%20API%20Key%20Request" className="btn btn-warning btn-sm me-2 fw-bold">
                    <i className="fa-solid fa-key me-1"></i> Get Sandbox API Key
                  </a>
                  <a href="tel:+917311104571" className="btn btn-outline-light btn-sm fw-bold">
                    <i className="fa-solid fa-phone me-1"></i> Call Sales (+91 7311104571)
                  </a>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <h5 className="text-light small text-uppercase mb-2 font-weight-bold">
                    <i className="fa-solid fa-arrow-right-to-bracket text-primary me-2"></i>Sample JSON Request Body
                  </h5>
                  <pre className="bg-black text-info p-3 rounded border border-secondary font-monospace" style={{ fontSize: '0.85rem' }}>
                    <code>{apiDetails[selectedApi].requestSample}</code>
                  </pre>
                </div>
                <div className="col-lg-6">
                  <h5 className="text-light small text-uppercase mb-2 font-weight-bold">
                    <i className="fa-solid fa-arrow-right-from-bracket text-success me-2"></i>Sample JSON Response (200 OK)
                  </h5>
                  <pre className="bg-black text-success p-3 rounded border border-secondary font-monospace" style={{ fontSize: '0.85rem' }}>
                    <code>{apiDetails[selectedApi].responseSample}</code>
                  </pre>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* Feature Highlights */}
        <section className="verify_features section_space bg-light">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <span className="text-primary font-weight-bold text-uppercase small">Why Choose Verify</span>
                <h2 className="heading_text text-dark mt-2">Built for Scale, Security &amp; Developer Simplicity</h2>
                <p className="text-muted">
                  Verify APIs are designed to handle millions of queries per day with Bank-grade encryption, instant failover fallback nodes, and zero manual intervention.
                </p>
                <div className="row g-3 mt-3">
                  <div className="col-sm-6">
                    <div className="d-flex align-items-start">
                      <i className="fa-solid fa-bolt text-warning fa-2x me-3 mt-1"></i>
                      <div>
                        <h6 className="font-weight-bold text-dark mb-1">&lt; 500ms Latency</h6>
                        <p className="small text-muted mb-0">Lightning-fast response speeds for instant checkout onboarding.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="d-flex align-items-start">
                      <i className="fa-solid fa-shield-check text-success fa-2x me-3 mt-1"></i>
                      <div>
                        <h6 className="font-weight-bold text-dark mb-1">100% Compliant</h6>
                        <p className="small text-muted mb-0">Compliant with RBI, NSDL, UIDAI, and NPCI data standards.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Redesigned Sandbox Request Form */}
              <div className="col-lg-6">
                <div
                  className="p-4 p-lg-5 bg-white rounded-4 border-0 sandbox_form_card"
                  style={{ boxShadow: '0 20px 45px -15px rgba(15, 23, 42, 0.18)' }}
                >
                  {/* Scoped style block: guarantees typed text and
                      placeholders stay dark/legible on the light
                      #f8fafc field background, overriding any global
                      (e.g. dark-theme) CSS that might otherwise make
                      input text light/white and invisible. */}
                  <style>{`
                    .sandbox_form_card input.form-control,
                    .sandbox_form_card select.form-select,
                    .sandbox_form_card textarea.form-control {
                      color: #0f172a !important;
                    }
                    .sandbox_form_card input.form-control::placeholder,
                    .sandbox_form_card textarea.form-control::placeholder {
                      color: #94a3b8 !important;
                      opacity: 1 !important;
                    }
                    .sandbox_form_card input.form-control:focus,
                    .sandbox_form_card select.form-select:focus,
                    .sandbox_form_card textarea.form-control:focus {
                      color: #0f172a !important;
                      background-color: #ffffff !important;
                      box-shadow: 0 0 0 3px rgba(217, 119, 6, 0.15) !important;
                      border-color: #d97706 !important;
                    }
                  `}</style>

                  <div className="d-flex align-items-center gap-3 mb-1">
                    <div
                      className="d-inline-flex align-items-center justify-content-center rounded-circle bg-dark text-warning flex-shrink-0"
                      style={{ width: '46px', height: '46px' }}
                    >
                      <i className="fa-solid fa-code fa-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-dark fw-bold mb-0">Request Developer Sandbox Access</h4>
                      <p className="text-muted small mb-0">Get sandbox credentials within 24 hours &mdash; no card required.</p>
                    </div>
                  </div>

                  <hr className="my-4" style={{ borderColor: '#eef1f6' }} />

                  {submitStatus === 'success' && (
                    <div className="alert alert-success py-2 small mb-3" role="alert">
                      <i className="fa-solid fa-circle-check me-2"></i>
                      Thank you! Our API integration team will contact you shortly.
                    </div>
                  )}
                  {submitStatus === 'error' && (
                    <div className="alert alert-danger py-2 small mb-3" role="alert">
                      <i className="fa-solid fa-triangle-exclamation me-2"></i>
                      Something went wrong. Please try again or call us directly.
                    </div>
                  )}

                  <form onSubmit={handleFormSubmit}>
                    <div className="mb-3">
                      <label className="form-label small fw-bold text-dark mb-1">Business Name</label>
                      <div className="input-group">
                        <span
                          className="input-group-text bg-light border-end-0"
                          style={{ borderRadius: '10px 0 0 10px', color: '#94a3b8' }}
                        >
                          <i className="fa-solid fa-building"></i>
                        </span>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleFormChange}
                          className="form-control border-start-0 ps-0"
                          placeholder="e.g. Acme Fintech Pvt Ltd"
                          required
                          style={fieldStyle}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label small fw-bold text-dark mb-1">Work Email</label>
                        <div className="input-group">
                          <span
                            className="input-group-text bg-light border-end-0"
                            style={{ borderRadius: '10px 0 0 10px', color: '#94a3b8' }}
                          >
                            <i className="fa-solid fa-envelope"></i>
                          </span>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleFormChange}
                            className="form-control border-start-0 ps-0"
                            placeholder="sales@mokshiq.in"
                            required
                            style={fieldStyle}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label small fw-bold text-dark mb-1">Mobile Number</label>
                        <div className="input-group">
                          <span
                            className="input-group-text bg-light border-end-0"
                            style={{ borderRadius: '10px 0 0 10px', color: '#94a3b8' }}
                          >
                            <i className="fa-solid fa-phone"></i>
                          </span>
                          <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleFormChange}
                            className="form-control border-start-0 ps-0"
                            placeholder="+91 7311104571"
                            required
                            style={fieldStyle}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label small fw-bold text-dark mb-1">Subject</label>
                      <div className="input-group">
                        <span
                          className="input-group-text bg-light border-end-0"
                          style={{ borderRadius: '10px 0 0 10px', color: '#94a3b8' }}
                        >
                          <i className="fa-solid fa-tag"></i>
                        </span>
                        <input
                          type="text"
                          name="subject"
                          value={formData.subject}
                          onChange={handleFormChange}
                          className="form-control border-start-0 ps-0"
                          placeholder="e.g. Sandbox API Key Request"
                          required
                          style={fieldStyle}
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label small fw-bold text-dark mb-1">Required Verification APIs</label>
                      <div className="input-group">
                        <span
                          className="input-group-text bg-light border-end-0"
                          style={{ borderRadius: '10px 0 0 10px', color: '#94a3b8' }}
                        >
                          <i className="fa-solid fa-list-check"></i>
                        </span>
                        <select
                          name="requiredApis"
                          value={formData.requiredApis}
                          onChange={handleFormChange}
                          className="form-select border-start-0 ps-0"
                          style={fieldStyle}
                        >
                          <option>All Verify APIs Suite</option>
                          <option>Bank Account Verification Only</option>
                          <option>PAN &amp; Aadhaar Verification</option>
                          <option>GSTIN &amp; Business Search</option>
                        </select>
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="form-label small fw-bold text-dark mb-1">Message</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleFormChange}
                        className="form-control"
                        rows="3"
                        placeholder="Tell us a bit about your integration needs..."
                        required
                        style={textareaStyle}
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      disabled={submitting}
                      className="btn w-100 fw-bold py-3 border-0"
                      style={{
                        borderRadius: '12px',
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
                        color: '#f59e0b',
                        letterSpacing: '0.3px',
                        opacity: submitting ? 0.7 : 1
                      }}
                    >
                      {submitting ? (
                        <>Submitting... <i className="fa-solid fa-spinner fa-spin ms-2"></i></>
                      ) : (
                        <>Submit Sandbox Request <i className="fa-solid fa-arrow-right ms-2"></i></>
                      )}
                    </button>

                    <p className="text-center text-muted small mt-3 mb-0">
                      <i className="fa-solid fa-lock me-1"></i>
                      Your details are safe &amp; never shared with third parties.
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <FAQ 
          faqList={VerifyFaqs} 
          title="Verify API FAQs" 
          subtitle="Frequently asked questions about integrating Mokshiq Verification APIs." 
        />

      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default Verify;